import service from '../../config/axios.config';

export const fetchObjectivesInfo = () => service.get(`/objectivesSummary`);